(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ttb-oil-addon"] && !Shopify.designMode) return;
  try {
    (function () {
    function money(cents, format) {
      var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var token = new RegExp('\\{\\{\\s*amount[a-z_]*\\s*\\}\\}');
      return format && token.test(format) ? format.replace(token, amount) : '$' + amount;
    }

    function quantity(form) {
      var input = form && form.querySelector('input[name="quantity"]');
      var n = parseInt(input && input.value, 10);
      return n > 0 ? n : 1;
    }

    function sync(addon) {
      var check = addon.querySelector('[data-ttb-addon-check]');
      var formId = addon.getAttribute('data-form-id');
      var form = document.getElementById(formId);
      var on = !!(check && check.checked && !check.disabled);
      var host = form && form.closest('product-form-component');
      if (host) host.setAttribute('data-ttb-oil', on ? 'on' : 'off');

      var n = quantity(form);
      var towel = Number(addon.getAttribute('data-towel-cents')) * n;
      var oil = Number(addon.getAttribute('data-oil-cents'));
      var savings = Number(addon.getAttribute('data-savings-cents'));
      var format = addon.getAttribute('data-money-format');
      var towelOut = addon.querySelector('[data-ttb-addon-towel]');
      var total = addon.querySelector('[data-ttb-addon-total]');
      if (towelOut) towelOut.textContent = money(towel, format);
      if (total) total.textContent = money(towel + oil - savings, format);

      var qty = form && form.querySelector('[data-ttb-addon-qty]');
      if (qty) qty.disabled = !on;
      var cta = document.querySelector('[data-ttb-addon-cta="' + formId + '"]');
      if (cta && !cta.hasAttribute('data-sold-out')) {
        cta.textContent = on
          ? 'Add both to cart — ' + money(towel + oil - savings, format)
          : 'Add ' + addon.getAttribute('data-towel-short') + ' to cart — ' + money(towel, format);
      }

      document.querySelectorAll('[data-ttb-addon-link]').forEach(function (link) {
        link.setAttribute('data-state', on ? 'on' : 'off');
      });
    }

    function all() {
      document.querySelectorAll('[data-ttb-addon]').forEach(sync);
    }

    document.addEventListener('change', function (event) {
      var check = event.target.closest('[data-ttb-addon-check]');
      if (check) {
        document.querySelectorAll('[data-ttb-addon-check]').forEach(function (other) {
          if (other !== check && !other.disabled) other.checked = check.checked;
        });
        return all();
      }
      if (event.target.matches('input[name="quantity"]')) all();
    });
    document.addEventListener('click', function (event) {
      if (event.target.closest('quantity-selector-component button')) requestAnimationFrame(all);
      var link = event.target.closest('[data-ttb-addon-link]');
      if (!link) return;
      var addon = document.querySelector('[data-ttb-addon]');
      var check = addon && addon.querySelector('[data-ttb-addon-check]');
      if (!check) return;
      event.preventDefault();
      if (!check.checked && !check.disabled) {
        check.checked = true;
        check.dispatchEvent(new Event('change', { bubbles: true }));
      }
      addon.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    function init() {
      document.querySelectorAll('[data-ttb-addon-cta][disabled]').forEach(function (cta) { cta.setAttribute('data-sold-out', ''); });
      all();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ttb-towel-addon"] && !Shopify.designMode) return;
  try {
    (function () {
    var formatMoney = null;

    function money(cents, format, currency) {
      if (formatMoney && format && currency) return formatMoney(cents, format, currency);
      var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var token = new RegExp('\\{\\{\\s*amount[a-z_]*\\s*\\}\\}');
      return format && token.test(format) ? format.replace(token, amount) : '$' + amount;
    }

    function quantity(form) {
      var input = form && form.querySelector('input[name="quantity"]');
      var n = parseInt(input && input.value, 10);
      return n > 0 ? n : 1;
    }

    function sync(upsell) {
      var check = upsell.querySelector('[data-ttb-upsell-check]');
      var formId = upsell.getAttribute('data-form-id');
      var form = document.getElementById(formId);
      var on = !!(check && check.checked);
      var host = form && form.closest('product-form-component');
      if (host) host.setAttribute('data-ttb-upsell', on ? 'on' : 'off');

      var main = Number(upsell.getAttribute('data-main-cents')) * quantity(form);
      var kit = main + Number(upsell.getAttribute('data-towel-cents')) - Number(upsell.getAttribute('data-savings-cents'));
      var format = upsell.getAttribute('data-money-format');
      var currency = upsell.getAttribute('data-currency');
      var mainOut = upsell.querySelector('[data-ttb-upsell-main]');
      var total = upsell.querySelector('[data-ttb-upsell-total]');
      if (mainOut) mainOut.textContent = money(main, format, currency);
      if (total) total.textContent = money(kit, format, currency);

      var cta = document.querySelector('[data-ttb-upsell-cta="' + formId + '"]');
      if (cta) {
        cta.textContent = on
          ? 'Add both to cart — ' + money(kit, format, currency)
          : 'Add to cart — ' + money(main, format, currency);
      }
    }

    function all() {
      document.querySelectorAll('[data-ttb-upsell]').forEach(sync);
    }

    document.addEventListener('change', function (event) {
      var check = event.target.closest('[data-ttb-upsell-check]');
      if (check) {
        document.querySelectorAll('[data-ttb-upsell-check]').forEach(function (other) {
          if (other !== check) other.checked = check.checked;
        });
        return all();
      }
      if (event.target.matches('input[name="quantity"]')) all();
    });
    document.addEventListener('quantity-selector:update', all);
    document.addEventListener('shopify:section:load', all);

    import('@theme/money-formatting')
      .then(function (module) {
        formatMoney = module.formatMoney;
        all();
      })
      .catch(function () {});

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', all);
    } else {
      all();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
